module.exports = __webpack_public_path__ + "static/media/ks_shack_clipboard_highlight.5854930f.svg";